import { defineStore } from 'pinia'

export const useCmsStore = defineStore('CmsStore', {
  persist: {
    storage: persistedState.localStorage,
  },
  state: () => ({
    post: [],
    categories: [],
    contexts: [],
    banner: [],
    news: [],
    newsBanner: [],
    postListSearch: '',
    postListPerPage: 20,
    postListPage: 1,
    postListRowCount: 0,
    indexPost: [],
  }),
  actions: {
    fetchDataIndexNews () {
      const data = {
        'instance': 1,
        'noBanner': true,
        'searchtag': ['#SomosEcoparque', '#SomosMomentos', '#SomosCuidado'],
      }

      return new Promise( ( resolve, reject ) => {
        $api('cms/getNews', { body: data })
          .then(response => {
            if (response.news) this.indexPost = response.news
            resolve(response)
          })
          .catch(reject)
      })
    },
    fetchDataNews (data) {
      return new Promise((resolve, reject) => {
        const params = {
          instance: data.instanceId,
          noBanner: data.noBanner,
          getCategories: data.getCategories,
          searchtag: data.searchtag,
        }

        $api('cms/getNews', { body: data })
          .then(response => {
            if (response.news) this.news = response.news
            if (response.banner) this.newsBanner = response.banner
            if (response.categories) this.categories = response.categories
            resolve(response)
          })
          .catch(reject)
      })
    },
    fetchDataVisit (slug) {
      return new Promise((resolve, reject) => {
        $api(`cms/visit?slug=${slug}`, { method: 'GET' })
          .then(response => {
            const productIndex = this.post.findIndex(p => p.CCNT_PK === response.CCNT_PK)
            if (productIndex === -1) {
              this.post.unshift(response)
            } else {
              Object.assign(this.post[productIndex], response)
            }
            resolve(response)
          })
          .catch(reject)
      })
    },
    fetchDataListPosts () {
      const addparams = `rows=${this.postListPerPage}&page=${this.postListPage}&search=${this.postListSearch}`
      
      return new Promise((resolve, reject) => {
        $api(`cms/get?getAll=true&${addparams}`, { method: 'GET' })
          .then(response => {
            this.post = response.post
            if (response.categories) this.categories = response.categories
            if (response.totalRows) this.postListRowCount = response.totalRows
            resolve(response)
          })
          .catch(reject)
      })
    },
    fetchDataListBanner () {
      return new Promise((resolve, reject) => {
        $api('cms/getBanner', { method: 'GET' })
          .then(response => {
            this.banner = response
            resolve(response)
          })
          .catch(reject)
      })
    },
    addPost (post) {
      const data = new FormData()

      Object.keys(post).forEach(key => data.append(key, post[key]))
  
      return new Promise((resolve, reject) => {
        $api('cms/post/store', { body: data, files: true })
          .then(response => {
            this.post.unshift({ ...post, CCNT_PK: response.data.CCNT_PK })
            resolve(response.data)
          })
          .catch(reject)
      })
    },
    updatePost (post) {
      const data = new FormData()

      Object.keys(post).forEach(key => data.append(key, post[key]))
  
      return new Promise((resolve, reject) => {
        $api('cms/post/store', { body: data, files: true })
          .then(response => {
            const productIndex = this.post.findIndex(p => p.CCNT_PK === response.data.CCNT_PK)
            if (productIndex === -1) {
              this.post.unshift(response.data)
            } else {
              Object.assign(this.post[productIndex], response.data)
            }
            resolve(response.data)
          })
          .catch(reject)
      })
    },
    addBanner (post) {
      const data = new FormData()

      Object.keys(post).forEach(key => data.append(key, post[key]))
  
      return new Promise((resolve, reject) => {
        $api('cms/banner/store', { body: data, files: true })
          .then(response => {
            this.banner.unshift({ ...post, CCNT_PK: response.data.CCNT_PK })
            resolve(response.data)
          })
          .catch(reject)
      })
    },
    updateBanner (post) {
      const data = new FormData()

      Object.keys(post).forEach(key => data.append(key, post[key]))
  
      return new Promise((resolve, reject) => {
        $api('cms/banner/store', { body: data, files: true })
          .then(response => {
            const productIndex = this.banner.findIndex(p => p.BNNR_PK === response.data.BNNR_PK)
            if (productIndex === -1) {
              this.banner.unshift(response.data)
            } else {
              Object.assign(this.banner[productIndex], response.data)
            }
            resolve(response.data)
          })
          .catch(reject)
      })
    },
    removePost (postId) {
      return new Promise((resolve, reject) => {
        $api('cms/post/delete', { body: { CCNT_PK: postId } })
          .then(response => {
            this.post = this.post.filter(p => p.CCNT_PK !== postId)
            resolve(response)
          })
          .catch(reject)
      })
    },
    publishPost (postId) {
      const productIndex = this.post.findIndex(p => p.CCNT_PK === postId)
      if (productIndex === -1) return

      const url = this.post[productIndex].CCNT_published === '0' || this.post[productIndex].CCNT_published === 0 
        ?'cms/post/publish'
        :'cms/post/conceal'
        
      return new Promise((resolve, reject) => {
        $api(url, { body: { CCNT_PK: postId } })
          .then(response => {
            const postIndex = this.post.findIndex(p => p.CCNT_PK === response.CCNT_PK)
            if (postIndex === -1) {
              this.post.unshift(response)
            } else {
              Object.assign(this.post[postIndex], response)
            }
            resolve(response)
          })
          .catch(reject)
      })
    },
    fetchDataCategory () {
      return new Promise((resolve, reject) => {
        $api('cms/Category/get', { method: 'GET' })
          .then(response => {
            this.categories =  response.categories
            this.contexts = response.contexts
            resolve(response)
          })
          .catch(reject)
      })
    },
    addCategory (category) {
      return new Promise((resolve, reject) => {
        $api('cms/Category/store', { body: category })
          .then(response => {
            this.categories.unshift({ ...category, CCTR_PK: category.CCTR_PK })
            resolve(response)
          })
          .catch(reject)
      })
    },
    updateCategory (category) {
      return new Promise((resolve, reject) => {
        $api('cms/Category/store', { body: category })
          .then(response => {
            const index = this.categories.findIndex(c => c.CCTR_PK === category.CCTR_PK)
            if (index !== -1) {
              Object.assign(this.categories[index], category)
            }
            resolve(response)
          })
          .catch(reject)
      })
    },
    setCmsPerPage (postListPerPage) {
      this.postListPerPage = postListPerPage
    },
    setCmsPageNumber (postListPage) {
      this.postListPage = postListPage
    },
    setCmsProfileQuery (postListSearch) {
      this.postListSearch = postListSearch
    },
    toggleShowDetails (post) {
      const productIndex = this.post.findIndex(p => p.CCNT_PK === post.CCNT_PK)
      if (productIndex !== -1) {
        post._showDetails = typeof post._showDetails !== 'undefined' ? !post._showDetails : true
        // eslint-disable-next-line
        post.CCNT_showing = post._showDetails
        Object.assign(this.post[productIndex], post)
      }
    },
  },
})
